// src/utils/minioUrls.ts
import { MEDIA_HOST, MEDIA_BUCKET, GAME_PREFIX } from "../config";

const host = (MEDIA_HOST || "").replace(/\/+$/, "");
const baseFor = (model: string) =>
  `${host}/${MEDIA_BUCKET}/games/${GAME_PREFIX}/models/${model}`;

// If your bucket uses "album" (singular), change this to "album"
const ALBUM_DIR = "albums";

export function buildPairs(model: string, album: string, count = 10) {
  const base = baseFor(model);
  const dir = `${base}/${ALBUM_DIR}/${album}`;

  return Array.from({ length: count }, (_, i) => {
    const idx = i + 1;
    return {
      blur:  `${dir}/${idx}_blurred.png`,
      clear: `${dir}/${idx}.png`,        // <-- now includes album folder
    };
  });
}

export function getCoverPath(model: string, album: string) {
  const base = baseFor(model);
  const dir = `${base}/${ALBUM_DIR}/${album}`;

  return `${dir}`;
}
